var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.word),function(letter,key){return _c('span',{staticClass:"letter",style:({
    'color' : key in _vm.style ? _vm.style [key] [0] : '',
    'font-size' : key in _vm.style ? _vm.style [key] [1] + 'px' : ''
  })},[_vm._v(_vm._s(letter))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }